import React from 'react';
import { faTimesHexagon } from '@fortawesome/pro-regular-svg-icons/faTimesHexagon';
import { Box, Container, Icon, PageContent, Text } from 'bumbag';

function Failed() {
  return (
    <Container isFluid>
      <PageContent
        alignX="center"
        maxWidth="400px"
        wrapperProps={{
          backgroundColor: 'white600',
          border: 'none',
        }}
      >
        {/* @ts-expect-error TS(2322): Type 'IconDefinition' is not assignable to type 's... Remove this comment to see the full error message */}
        <Icon icon={faTimesHexagon} type="font-awesome" fontSize="200px" marginRight="major-1" color="danger" />
        <Box marginTop="major-2" textAlign="center">
          <Text fontSize="1.2rem">Your request has been unsuccessful.</Text>
        </Box>
      </PageContent>
    </Container>
  );
}

export default Failed;
